import InfoIcon from "@material-ui/icons/Info";
import SettingsIcon from "@material-ui/icons/Settings";
import { IRoute } from "src/common/typings/routes";
import { AssignPermissions } from "./roles/pages/AssignPermissions/AssignPermissions";
import { ListRoles } from "./roles/pages/ListRoles";
import { AddNewUser } from "./users/pages/AddNewUser";
import { ListUsers } from "./users/pages/ListUsers/index";
import { UpdateUser } from "./users/pages/UpdateUser";
import { Terminal } from "./terminal";
import { Setting } from "./setting";

export const SettingsRoute: IRoute = {
  title: "Settings",
  path: "/setting",
  icon: SettingsIcon,
  component: Setting,
  guard: true,
  subRoutes: [
    { icon: InfoIcon, component: Terminal, path: "/terminals", title: "Terminals" },
    { icon: InfoIcon, component: ListUsers, path: "/list-users", title: "List of Users" },
    { icon: InfoIcon, component: ListRoles, path: "/roles", title: "List of Roles" },

    {
      icon: InfoIcon,
      component: AddNewUser,
      path: "/add-user",
      title: "Add New User",
      noDrawer: true,
    },
    {
      component: UpdateUser,
      path: "/update-user",
      pathParam: "/:id",
      title: "Update User",
      noDrawer: true,
    },
    {
      component: AssignPermissions,
      path: "/assign-permissions",
      pathParam: "/:id/:terminalId",
      title: "Assign Permissions",
      noDrawer: true,
    },
  ],
};
